import axios from 'axios'
import store from '@/store'
import { getToken,setToken } from '@/utils/auth'
import router from '@/router'
import Cookies from 'js-cookie'
import {Message} from "element-ui";

// 创建axios实例
const service = axios.create({
  baseURL: 'https://back2.hajimehaji.me/api',
    // baseURL: 'http://localhost:9085/api',
  timeout: 5000
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    if (store.getters.token) {
      config.headers['satoken'] = getToken()
    }
    return config
  },
  error => {
    console.log(error)
    return Promise.reject(error)
  }
)

service.interceptors.response.use(
    response => {
        const res = response.data
        if (res.code !== 200) {
            if (res.code === 401) {
                Message.error('登录已过期，请重新登录')
                store.dispatch('user/resetToken').then(() => {
                    if (router.currentRoute.path !== '/login') {
                        router.replace('/login')
                    }
                })
                return Promise.resolve({ code: 401, message: '登录过期' })
            }
            console.log('res',res)
            Message.error(res.message || '请求出错')
            return Promise.reject(new Error(res.message || 'Error'))
        }
        if (res.message)
        Message.success(res.message)
        return res
    },

    error => {
        if (error.response && error.response.data && error.response.data.message) {
            Message.error(error.response.data.message)
        } else {
            Message.error(error.message || '请求失败')
        }
        return Promise.reject(error)
    }
)


export default service
